import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../../common/constants';
import { isEmptyArray } from '../../common/util.services';
import { getProduct } from './product.services';

const AmzVirtualProductList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [productData, setProductData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'sku', headerName: 'Virtual SKU', filterable: false, sortable: false, editable: false, width: 300 },
    { field: 'product', headerName: 'Products', filterable: false, sortable: false, editable: false, width: 950 }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getProduct(page, pageSize, appContext,
        (response: any) => {
          setProductData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.rowId);
  };

  const addProduct = () => {
    navigate('new');
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={productData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={true} handleEditAction={handleEditAction} showAddBtn={true}
        showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} addRow={addProduct} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='Virtual Products' panelBody={getMainPanel()} />
}

export default AmzVirtualProductList;